import axios, { AxiosInstance } from 'axios';
import { ServerRequest } from '../types/request.types';
import downloadFile from "../helpers/downloadFile";

const S3_MAC_BUILDS_URL = process.env.REACT_APP_S3_MAC_BUILDS_URL;
const S3_WINDOWS_BUILDS_URL = process.env.REACT_APP_S3_WINDOWS_BUILDS_URL;

export default class DownloadService {
  private httpClient: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.httpClient = client;
  }

  async downloadBeta(version: string, buildType: string): Promise<ServerRequest<any>> {
    const baseURL = buildType === "mac" ? S3_MAC_BUILDS_URL : S3_WINDOWS_BUILDS_URL;
    const response = await this.httpClient({url: version, baseURL, responseType: 'blob'});
    downloadFile(response.data,`${version}`, 'application/octet-stream')
    return response.data;
  }
}

export const downloadService = new DownloadService(axios);
